
import {
  EditableRow,
  EditableCell,
} from "../../../../components/table/TableEditAble";
import { formatMoney } from "../../../../utils/util";
import { docLinkRender } from "../../../../components/table/DocLink";
import { 
  // BadgeSamplePreparationStatus, 
  TagCalBom
} from "../../../../components/badge-and-tag/ERP";

export const componentsEditable = {
  body: { row: EditableRow, cell: EditableCell },
};

export const accessColumn = ({ openJo } = {}) => [
  {
    title: "รหัส JO",
    dataIndex: "jocode",
    key: "jocode",
    sorter: (a, b) => (a?.jocode || "").localeCompare(b?.jocode || ""),
    width: 100,
    /* กดรหัสเพื่อเปิดหน้า Job Order ปุ่มกลับจะพากลับมาหน้ารายงานนี้ */
    render: docLinkRender((rec) => openJo && openJo(rec?.jocode), "เปิดดู Job Order"),
  },
  {
    title: "ลูกค้า",
    dataIndex: "cusname",
    key: "cusname",
    sorter: (a, b) => (a?.cusname || "").localeCompare(b?.cusname || ""),
    width: 280,
  },
  {
    title: "PG Code",
    dataIndex: "pg_code",
    key: "pg_code",
    width: 140,
  },
  // {
  //   title: "Order",
  //   dataIndex: "pi_no",
  //   key: "pi_no",
  //   width: "25%",
  //   sorter: (a, b) => (a?.pi_no || "").localeCompare(b?.pi_no || ""),
  //   ellipsis: { showTitle: false, },
  //   render: (v) => <Tooltip placement="topLeft" title={v}>{v}</Tooltip>,
  // },
  {
    title: "PG Name",
    align: "left",
    key: "pg_name",
    dataIndex: "pg_name",
  },
  {
    title: "FG Name",
    align: "left",
    key: "fg_code",
    dataIndex: "fg_name",
  },
  {
    title: "BOM",
    align: "left",
    key: "bom",
    width: 100,
    dataIndex: "bom",
    render: (t, v) => v?.bom ? <TagCalBom result={v.bom} /> : null,
  },
  {
    title: "Code",
    align: "left",
    key: "code",
    width: 60,
    dataIndex: "code",
  },
  {
    title: <>จำนวนกล่อง</>,
    align: "right",
    width: 80,
    editable: true,
    required: false,
    key: "carton",
    dataIndex: "carton",
    className: "field-edit pe-2",
    type: "input",
  },
  {
    title: <>Unit/cs</>,
    align: "right",
    width: 60,
    // editable: true,
    // required: false,
    key: "unit_cs",
    dataIndex: "unit_cs",
    className: "field-edit pe-2",
    type: "input",
  },
  {
    title: <>จำนวน Unit</>,
    align: "right",
    width: 100,
    key: "total_unit",
    dataIndex: "total_unit",
    className: "field-edit pe-2",
    render: (t, v) => v?.pg_code ? (formatMoney(Number(v.carton) * Number(v.unit_cs))):null,
  },
];

export const materialColumn = ({}) => [
  {
    title: "รหัส วัตถุดิบ",
    dataIndex: "mat_code",
    key: "mat_code",
    sorter: (a, b) => (a?.mat_code || "").localeCompare(b?.mat_code || ""),
    width: 140,
  },
  {
    title: "ชื่อวัตถุดิบ",
    dataIndex: "mat_name",
    key: "mat_name",
  },
  // {
  //   title: "รหัส",
  //   dataIndex: "code",
  //   key: "code",
  //   align: "left",
  //   width: 100,
  // },
  // {
  //   title: "รหัสวัตถุดิบหลัก",
  //   dataIndex: "parent_item_code",
  //   key: "parent_item_code",
  //   width: 300,
  // },
  {
    title: "Stock",
    align: "left",
    key: "stock",
    dataIndex: "stock",
    width: 140,
  },
  {
    title: "จำนวนต้องการ",
    align: "left",
    key: "qty",
    dataIndex: "qty",
    width: 140,
    render: (t, v) => (formatMoney(Number(v.qty), 2)),
  },
  {
    title: "จำนวนขาด/เกิน",
    align: "left",
    key: "diff",
    dataIndex: "diff",
    width: 140,
    render: (t, v) => (formatMoney(Number(v.stock) - Number(v.qty), 2)),
  },
  {
    title: "หน่วย",
    align: "center",
    key: "unit",
    dataIndex: "unit",
    width: 140,
  },
];


